import qs from 'qs';

const MAX_FETCH_ATTEMPTS = 3;

const fetchAndRetry = async (url = '') => {
  let attempts = 0;
  let error = null;

  while (attempts < MAX_FETCH_ATTEMPTS) {
    try {
      return await fetch(url);
    } catch (e) {
      attempts++;
      error = e;
    }
    await new Promise((resolve) => setTimeout(resolve, 100 * attempts));
  }
  if (error) throw error;
};

export const fetchTrainAudio = async () => {
  const query = qs.stringify(
    {
      populate: [
        "audio",
      ],
      pagination: {
        page: 1,
        pageSize: 100,
      },
    },
    {
      encodeValuesOnly: true,
    }
  );

  try {
    const response = await fetchAndRetry(
      `${process.env.REACT_APP_API_URL}/api/train-audio-v2s?${query}`
    );

    if (!response.ok) {
      throw new Error(response.statusText);
    }

    const data = await response.json();

    return data.data;
  } catch (error) {
    return [];
  }
};

export const fetchTrainAudioMedia = async (item) => {
  const { attributes } = item || {};
  const { audio } = attributes || {};
  const { attributes: audioAttrs = {} } = audio.data || {};

  const promises = [];
  if (audioAttrs.url) promises.push(fetchAndRetry(audioAttrs.url).catch(err => console.log('media audio error', err)));

  return Promise.all(promises);
};
